import { render, staticRenderFns } from "./IkasChannels.vue?vue&type=template&id=9120c016&scoped=true"
import script from "./IkasChannels.vue?vue&type=script&lang=js"
export * from "./IkasChannels.vue?vue&type=script&lang=js"
import style0 from "./IkasChannels.vue?vue&type=style&index=0&id=9120c016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9120c016",
  null
  
)

export default component.exports